import { Contributors, OperationsData, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const CustomersListPage = lazyPage(() => import("../customers/CustomersListPage"), "CustomersListPage");
const CustomerProfilePage = lazyPage(() => import("../customers/CustomerProfilePage"), "CustomerProfilePage");
const MyBriefSchedulesPage = lazyPage(() => import("../customers/MyBriefSchedulesPage"), "MyBriefSchedulesPage");

/**
 * Operations Customers section routes (Gate D, W6, D-O71, D-O73, D-O62, D-O84):
 * - /customers (Customer NAME groups with their customer IDs, open work, at-risk count, deterministic health badge, filter/search)
 * - /customers/:code (Customer profile with Overview, Shipped, In the queue, Forecast, Communications, and Briefs tabs)
 * - /customers/my-briefs (release 1.3.0, O-R49: the signed-in person's brief schedules and the briefs waiting for them to send)
 */
export const CustomersHubReaders: readonly Role[] = OperationsData;

/** Who schedules customer briefs (the API policy for creating one is Contributors). */
export const MyBriefScheduleReaders: readonly Role[] = Contributors;

export { CustomersListPage, CustomerProfilePage, MyBriefSchedulesPage };

export const customersHubRoutes: AreaRoute[] = [
  {
    path: "/customers",
    allow: CustomersHubReaders,
    element: <CustomersListPage />
  },
  {
    path: "/customers/my-briefs",
    allow: CustomersHubReaders,
    element: <MyBriefSchedulesPage />
  },
  {
    path: "/customers/:code",
    allow: CustomersHubReaders,
    element: <CustomerProfilePage />
  }
];
